import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';
import {USE_DARK_MODE_INFO_BADGE_COLORS_ATTRIBUTE} from '../HtmlAttributes';

export const BillsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "Bills" */
      '../../../components/Treasury/Bills/Bills'
    ),
  teamOwner: 'treasury',
  sentryTeam: 'treasury_surfaces',
  releaseState: 'preview',
  description: 'A list of bills for a connected account.',
  friendlyName: 'Bills',
  enableV2APIToken: true,
  htmlAttributes: {
    [USE_DARK_MODE_INFO_BADGE_COLORS_ATTRIBUTE]: {
      isInternal: true,
    },
  },
  customHtmlElementMethods: {
    setTreasuryEntryAction: {
      type: 'SupplementalObject',
      objectToSet: 'treasuryEntryAction',
      isInternal: true,
      description: 'Opens bill upload for a checklist action with a unique ID.',
    },
    setUseDarkModeInfoBadgeColors: {
      type: 'AttributeSettingMethod',
      attribute: USE_DARK_MODE_INFO_BADGE_COLORS_ATTRIBUTE,
      isInternal: true,
      description:
        'Sets whether Bills info badges use the Express dark mode color palette.',
    },
  },
};
